import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const InteriorsTypes = ({ form, interiorsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Интерьер">
      {getFieldDecorator('interior_component_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {interiorsTypes &&
            interiorsTypes.map(type => (
              <Option
                key={type.interiorComponentKey}
                value={type.interiorComponentKey}
                label={type.interiorComponentName}
              >
                {type.interiorComponentName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(InteriorsTypes, ['interiorsTypes']);
